import { render } from "./shekh.vue?vue&type=template&id=6f53c267"
import script from "./shekh.vue?vue&type=script&lang=js"
export * from "./shekh.vue?vue&type=script&lang=js"
script.render = render

export default script